import "../css/Footer.css"
import * as React from "react";
import { Link } from "react-router-dom";

/**
 * 管理者フッタ
 * @returns 
 */
function FooterAdmin() {
  return (
    <>
      <footer className="footer01">
        <p className="copyright">
          Copyright : Ministry of Agriculture, Forestry and Fisheries
        </p>
      </footer>
    </>
  );
}

export default FooterAdmin;
